export default __webpack_public_path__ + "static/media/Montserrat-Normal.3cd78665.ttf";